import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useParams, Link, useNavigate } from 'react-router-dom';
import {
    FaSearch, FaPlus, FaEdit, FaTrash,
    FaUserNinja, FaMars, FaVenus, FaFileExport, FaSync,
    FaRedo, FaFilePdf, FaSpinner, FaUpload, FaTimes, FaExclamationTriangle
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../api/axios';
import { Document, Page, Text, View, StyleSheet, pdf } from '@react-pdf/renderer';

const getGenderLabel = (gender) => {
    if (gender === 'Lelaki' || gender === 'L') return 'Putra';
    if (gender === 'Perempuan' || gender === 'P') return 'Putri';
    return gender || '-';
};

const pdfStyles = StyleSheet.create({
    page: { padding: 20, fontSize: 9, fontFamily: 'Helvetica' },
    header: { marginBottom: 15, textAlign: 'center' },
    title: { fontSize: 14, fontWeight: 'bold', textTransform: 'uppercase' },
    subtitle: { fontSize: 9, color: '#666', marginTop: 4, paddingHorizontal: 30 },
    table: { display: "table", width: "auto", borderStyle: "solid", borderWidth: 1, borderRightWidth: 0, borderBottomWidth: 0, marginTop: 10 },
    tableRow: { margin: "auto", flexDirection: "row", flexWrap: 'wrap' },
    tableColHeader: { borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, backgroundColor: '#e2e8f0', padding: 5 },
    tableCol: { borderStyle: "solid", borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, padding: 4 },
    tableCellHeader: { fontWeight: 'bold', fontSize: 7.5, textAlign: 'center', textTransform: 'uppercase' },
    tableCell: { fontSize: 7, textAlign: 'center' },

    colNo: { width: '4%' },
    colName: { width: '20%' },
    colTeam: { width: '14%' },
    colGender: { width: '8%' },
    colStatus: { width: '10%' },
    colMedal: { width: '9%' },
    colDynamic: { width: '10%' }
});

const KyorugiReportPDF = ({ data, filters, activeTab }) => {
    const currentYear = new Date().getFullYear();

    return (
        <Document>
            <Page size="A4" orientation="landscape" style={pdfStyles.page}>
                <View style={pdfStyles.header}>
                    <Text style={pdfStyles.title}>Laporan Data Atlet {activeTab.label}</Text>
                    <Text style={pdfStyles.subtitle}>
                        Data diexport berdasarkan filter: Gender "{filters.gender || 'Semua'}", Pencarian "{filters.search || '-'}"
                    </Text>
                </View>

                <View style={pdfStyles.table}>
                    <View style={pdfStyles.tableRow} fixed>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colNo]}>
                            <Text style={pdfStyles.tableCellHeader}>No</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colName]}>
                            <Text style={pdfStyles.tableCellHeader}>Nama Atlet</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colTeam]}>
                            <Text style={pdfStyles.tableCellHeader}>Kontingen</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colGender]}>
                            <Text style={pdfStyles.tableCellHeader}>Gender</Text>
                        </View>

                        {activeTab.id === 'kyorugi_prestasi' && (
                            <>
                                <View style={[pdfStyles.tableColHeader, pdfStyles.colDynamic]}>
                                    <Text style={pdfStyles.tableCellHeader}>Divisi</Text>
                                </View>
                                <View style={[pdfStyles.tableColHeader, { width: '22%' }]}>
                                    <Text style={pdfStyles.tableCellHeader}>Kelas Tanding</Text>
                                </View>
                            </>
                        )}

                        {activeTab.id === 'kyorugi_festival' && (
                            <>
                                <View style={[pdfStyles.tableColHeader, { width: '8%' }]}>
                                    <Text style={pdfStyles.tableCellHeader}>Umur</Text>
                                </View>
                                <View style={[pdfStyles.tableColHeader, { width: '8%' }]}>
                                    <Text style={pdfStyles.tableCellHeader}>Berat</Text>
                                </View>
                                <View style={[pdfStyles.tableColHeader, { width: '8%' }]}>
                                    <Text style={pdfStyles.tableCellHeader}>Tinggi</Text>
                                </View>
                                <View style={[pdfStyles.tableColHeader, { width: '10%' }]}>
                                    <Text style={pdfStyles.tableCellHeader}>Sabuk</Text>
                                </View>
                            </>
                        )}

                        <View style={[pdfStyles.tableColHeader, pdfStyles.colStatus]}>
                            <Text style={pdfStyles.tableCellHeader}>Status</Text>
                        </View>
                        <View style={[pdfStyles.tableColHeader, pdfStyles.colMedal]}>
                            <Text style={pdfStyles.tableCellHeader}>Medali</Text>
                        </View>
                    </View>

                    {(data || []).map((item, index) => (
                        <View style={pdfStyles.tableRow} key={item.uuid || index} wrap={false}>
                            <View style={[pdfStyles.tableCol, pdfStyles.colNo]}>
                                <Text style={pdfStyles.tableCell}>{index + 1}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colName]}>
                                <Text style={pdfStyles.tableCell}>{item.name || '-'}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colTeam]}>
                                <Text style={pdfStyles.tableCell}>{item.team?.name || '-'}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colGender]}>
                                <Text style={pdfStyles.tableCell}>{getGenderLabel(item.gender)}</Text>
                            </View>

                            {activeTab.id === 'kyorugi_prestasi' && (
                                <>
                                    <View style={[pdfStyles.tableCol, pdfStyles.colDynamic]}>
                                        <Text style={pdfStyles.tableCell}>{item.division || '-'}</Text>
                                    </View>
                                    <View style={[pdfStyles.tableCol, { width: '22%' }]}>
                                        <Text style={pdfStyles.tableCell}>{item.weight_class || '-'}</Text>
                                    </View>
                                </>
                            )}

                            {activeTab.id === 'kyorugi_festival' && (
                                <>
                                    <View style={[pdfStyles.tableCol, { width: '8%' }]}>
                                        <Text style={pdfStyles.tableCell}>{item.birth_year ? currentYear - item.birth_year : '-'}</Text>
                                    </View>
                                    <View style={[pdfStyles.tableCol, { width: '8%' }]}>
                                        <Text style={pdfStyles.tableCell}>{item.actual_weight || item.declared_weight || '-'}</Text>
                                    </View>
                                    <View style={[pdfStyles.tableCol, { width: '8%' }]}>
                                        <Text style={pdfStyles.tableCell}>{item.height || '-'}</Text>
                                    </View>
                                    <View style={[pdfStyles.tableCol, { width: '10%' }]}>
                                        <Text style={pdfStyles.tableCell}>{item.belt || '-'}</Text>
                                    </View>
                                </>
                            )}

                            <View style={[pdfStyles.tableCol, pdfStyles.colStatus]}>
                                <Text style={pdfStyles.tableCell}>{item.weigh_in_status || 'Registered'}</Text>
                            </View>
                            <View style={[pdfStyles.tableCol, pdfStyles.colMedal]}>
                                <Text style={pdfStyles.tableCell}>{item.medal || '-'}</Text>
                            </View>
                        </View>
                    ))}
                </View>

                <Text style={{ marginTop: 15, fontSize: 7, textAlign: 'right', color: '#999' }}>
                    Dicetak pada: {new Date().toLocaleString('id-ID')}
                </Text>
            </Page>
        </Document>
    );
};

const AvatarWithFallback = ({ item, baseUrl }) => {
    const [imgError, setImgError] = useState(false);

    if (item.image && !imgError) {
        return (
            <img
                src={`${baseUrl}${item.image}`}
                alt={item.name}
                className="rounded-circle shadow-sm w-100 h-100 object-fit-cover border border-2 border-white"
                onError={() => setImgError(true)}
            />
        );
    }

    return (
        <div
            className="w-100 h-100 rounded-circle d-flex align-items-center justify-content-center text-white fw-bold shadow-sm"
            style={{ backgroundColor: item.gender === 'Lelaki' || item.gender === 'L' ? '#0d6efd' : '#dc3545' }}
        >
            {item.gender === 'Lelaki' || item.gender === 'L' ? <FaUserNinja /> : <FaVenus />}
        </div>
    );
};

const AdminAthleteKyorugi = () => {
    const { type } = useParams();
    const navigate = useNavigate();

    const currentType = type ? type.charAt(0).toUpperCase() + type.slice(1) : 'Prestasi';

    const activeTab = {
        id: `kyorugi_${currentType.toLowerCase()}`,
        label: `Kyorugi ${currentType}`,
        compType: 'Kyorugi',
        type: currentType
    };

    const [athletes, setAthletes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isExporting, setIsExporting] = useState(false);
    const [isPreparingPdf, setIsPreparingPdf] = useState(false);

    const [deleteModal, setDeleteModal] = useState({ show: false, uuid: null });
    const [importModal, setImportModal] = useState(false);
    const [isImporting, setIsImporting] = useState(false);

    const BACKEND_HOST = process.env.REACT_APP_BACKEND || '';
    const BASE_URL = `${BACKEND_HOST}/uploads/athletes/`;

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    const [searchTerm, setSearchTerm] = useState('');
    const [filterGender, setFilterGender] = useState('');
    const [filterAlone, setFilterAlone] = useState(false);

    const [importData, setImportData] = useState({
        import_type: 'Kyorugi',
        athlete_type: currentType,
        file: null
    });

    const fetchAthletes = async () => {
        setIsLoading(true);

        try {
            const response = await api.get('/athletes', {
                params: {
                    page,
                    limit,
                    search: searchTerm,
                    gender: filterGender,
                    competition_type: 'Kyorugi',
                    type: activeTab.type,
                    is_alone: filterAlone
                }
            });

            setAthletes(response.data.result || response.data.data || []);
            setTotalPages(response.data.totalPage || response.data.totalPages || 0);
            setTotalItems(response.data.totalRows || response.data.totalItems || 0);
        } catch (error) {
            toast.error("Gagal mengambil data atlet.");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const delay = setTimeout(() => {
            fetchAthletes();
        }, 500);

        return () => clearTimeout(delay);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit, searchTerm, filterGender, filterAlone, type]);

    useEffect(() => {
        setPage(1);
        setFilterAlone(false);
    }, [searchTerm, filterGender, type]);

    useEffect(() => {
        setImportData({
            import_type: 'Kyorugi',
            athlete_type: currentType,
            file: null
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    const executeDelete = async () => {
        try {
            await api.delete(`/athletes/${deleteModal.uuid}`);
            toast.success("Data atlet berhasil dihapus");
            setDeleteModal({ show: false, uuid: null });
            fetchAthletes();
        } catch (error) {
            toast.error("Gagal menghapus data.");
        }
    };

    const handleExportCsv = async () => {
        setIsExporting(true);

        try {
            const response = await api.get('/athletes/export/csv', {
                responseType: 'blob',
                params: {
                    search: searchTerm,
                    gender: filterGender,
                    competition_type: 'Kyorugi',
                    type: activeTab.type
                }
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', `Data_Atlet_${activeTab.label.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.csv`);

            document.body.appendChild(link);
            link.click();
            link.remove();

            toast.success("Data berhasil didownload!");
        } catch (error) {
            toast.error("Gagal mengexport data CSV.");
        } finally {
            setIsExporting(false);
        }
    };

    const handleDownloadPdf = async () => {
        setIsPreparingPdf(true);

        try {
            const response = await api.get('/athletes', {
                params: {
                    limit: 9999,
                    search: searchTerm,
                    gender: filterGender,
                    competition_type: 'Kyorugi',
                    type: activeTab.type
                }
            });

            const dataToExport = response.data.result || response.data.data || [];

            if (dataToExport.length === 0) {
                toast.warning("Tidak ada data untuk diexport!");
                setIsPreparingPdf(false);
                return;
            }

            const blob = await pdf(
                <KyorugiReportPDF
                    data={dataToExport}
                    filters={{ search: searchTerm, gender: filterGender }}
                    activeTab={activeTab}
                />
            ).toBlob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', `Laporan_${activeTab.label.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);

            document.body.appendChild(link);
            link.click();
            link.remove();

            toast.success("Dokumen PDF berhasil dibuat!");
        } catch (error) {
            console.error(error);
            toast.error("Gagal men-generate dokumen PDF.");
        } finally {
            setIsPreparingPdf(false);
        }
    };

    const openImportModal = () => {
        setImportData({
            import_type: 'Kyorugi',
            athlete_type: activeTab.type,
            file: null
        });
        setImportModal(true);
    };

    const submitImport = async (e) => {
        e.preventDefault();

        if (!importData.athlete_type || !importData.file) {
            return toast.warning("Pilih Tipe Pertandingan dan File CSV/Excel terlebih dahulu!");
        }

        setIsImporting(true);

        try {
            const formData = new FormData();

            formData.append('import_type', 'Kyorugi');
            formData.append('athlete_type', importData.athlete_type);
            formData.append('csv_file', importData.file);

            const res = await api.post('/athletes/import', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            toast.success(res.data.msg || "Atlet Kyorugi berhasil diimport.");
            setImportModal(false);
            setImportData({
                import_type: 'Kyorugi',
                athlete_type: activeTab.type,
                file: null
            });
            fetchAthletes();
        } catch (error) {
            toast.error(error.response?.data?.msg || "Gagal melakukan import.");
        } finally {
            setIsImporting(false);
        }
    };

    const handlePrevPage = () => {
        if (page > 1) setPage(page - 1);
    };

    const handleNextPage = () => {
        if (page < totalPages) setPage(page + 1);
    };

    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className="container-fluid p-0 animate-fade-in">
                <div className="d-flex flex-column justify-content-between mb-4 gap-3">
                    <div>
                        <h2 className="fw-bold text-dark mb-1 d-flex align-items-center w-100 gap-2">
                            <FaUserNinja className="text-primary" /> Data Atlet {activeTab.label}
                        </h2>
                        <p className="text-muted m-0">Total <b>{totalItems}</b> atlet terdaftar pada kategori ini.</p>
                    </div>

                    <div className="d-flex gap-2 flex-wrap">
                        <button onClick={() => { setPage(1); fetchAthletes(); }} className="btn btn-light rounded-circle shadow-sm" title="Refresh Data">
                            <FaSync className={isLoading || isPreparingPdf ? "fa-spin" : ""} />
                        </button>

                        <button onClick={openImportModal} className="btn btn-warning fw-bold text-dark d-flex align-items-center gap-2 shadow-sm hover-scale rounded-pill px-3">
                            <FaUpload /> Import CSV
                        </button>

                        <button onClick={handleExportCsv} disabled={isExporting} className="btn btn-dark d-flex align-items-center gap-2 shadow-sm hover-scale rounded-pill px-3">
                            {isExporting ? <div className="spinner-border spinner-border-sm" role="status"></div> : <FaFileExport />} Export CSV
                        </button>

                        <button
                            onClick={handleDownloadPdf}
                            disabled={isPreparingPdf}
                            className="btn btn-danger d-flex align-items-center gap-2 shadow-sm hover-scale rounded-pill px-3 fw-bold border-0"
                        >
                            {isPreparingPdf ? <><FaSpinner className="fa-spin" /> Menyiapkan...</> : <><FaFilePdf /> Export PDF</>}
                        </button>

                        <Link
                            to="/admin/atlet/tambah"
                            state={{ preselectedCompType: 'Kyorugi', preselectedType: activeTab.type }}
                            className="btn btn-primary d-flex align-items-center gap-2 shadow-lg hover-scale rounded-pill px-4 fw-bold"
                        >
                            <FaPlus /> Tambah
                        </Link>
                    </div>
                </div>

                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '20px' }}>
                    <div className="card-body p-4 bg-white rounded-4">
                        <div className="row g-3">
                            <div className={activeTab.id === 'kyorugi_prestasi' ? "col-lg-3" : "col-lg-6"}>
                                <div className="input-group">
                                    <span className="input-group-text border-end-0 bg-light ps-3 text-muted"><FaSearch /></span>
                                    <input
                                        type="text"
                                        className="form-control border-start-0 bg-light ps-2 py-2"
                                        placeholder={`Cari Nama Atlet di ${activeTab.label}...`}
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className={activeTab.id === 'kyorugi_prestasi' ? "col-md-2" : "col-md-3"}>
                                <select className="form-select py-2 bg-light" value={filterGender} onChange={(e) => setFilterGender(e.target.value)}>
                                    <option value="">Semua Gender</option>
                                    <option value="Lelaki">Putra</option>
                                    <option value="Perempuan">Putri</option>
                                </select>
                            </div>

                            {activeTab.id === 'kyorugi_prestasi' && (
                                <div className="col-md-4">
                                    <button
                                        className={`btn w-100 py-2 border hover-scale fw-bold d-flex justify-content-center align-items-center gap-2 ${filterAlone ? 'btn-danger text-white border-danger shadow-sm' : 'bg-light text-muted border'}`}
                                        onClick={() => { setFilterAlone(!filterAlone); setPage(1); }}
                                        title="Tampilkan Atlet Tanpa Lawan"
                                    >
                                        <FaExclamationTriangle />
                                        {filterAlone ? "Hanya Tanpa Lawan" : "Cek Tanpa Lawan"}
                                    </button>
                                </div>
                            )}

                            <div className="col-md-2">
                                <select className="form-select py-2 bg-light" value={limit} onChange={(e) => { setLimit(e.target.value); setPage(1); }}>
                                    <option value="10">10 Baris</option>
                                    <option value="25">25 Baris</option>
                                    <option value="50">50 Baris</option>
                                    <option value="100">100 Baris</option>
                                </select>
                            </div>

                            <div className="col-md-1">
                                <button
                                    className="btn btn-light w-auto py-2 border text-muted hover-scale"
                                    title="Reset Filter"
                                    onClick={() => {
                                        setSearchTerm('');
                                        setFilterGender('');
                                        setLimit(10);
                                        setPage(1);
                                        setFilterAlone(false);
                                    }}
                                >
                                    <FaRedo />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card border-0 shadow-sm" style={{ borderRadius: '20px', overflow: 'hidden', minHeight: '400px' }}>
                    <div className="card-body p-0">
                        {isLoading ? (
                            <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}></div>
                                <span className="text-muted fw-bold">Memuat data atlet...</span>
                            </div>
                        ) : athletes.length === 0 ? (
                            <div className="text-center py-5">
                                <FaUserNinja size={60} className="text-muted opacity-25 mb-3" />
                                <h5 className="text-muted fw-bold">Tidak ada data ditemukan.</h5>
                                <p className="small text-muted">Coba ubah kata kunci pencarian atau tambah atlet baru di kategori ini.</p>
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover align-middle mb-0" style={{ minWidth: '900px' }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th className="py-3 ps-4 text-muted small text-uppercase fw-bold border-0">Profil Atlet</th>
                                            <th className="py-3 text-muted small text-uppercase fw-bold border-0">Kontingen / Tim</th>

                                            {activeTab.id === 'kyorugi_prestasi' && (
                                                <>
                                                    <th className="py-3 text-muted small text-uppercase fw-bold border-0">Divisi</th>
                                                    <th className="py-3 text-muted small text-uppercase fw-bold border-0">Kelas Tanding</th>
                                                </>
                                            )}

                                            {activeTab.id === 'kyorugi_festival' && (
                                                <>
                                                    <th className="py-3 text-muted small text-uppercase fw-bold border-0">Umur</th>
                                                    <th className="py-3 text-muted small text-uppercase fw-bold border-0">Berat (Kg)</th>
                                                    <th className="py-3 text-muted small text-uppercase fw-bold border-0">Tinggi (Cm)</th>
                                                    <th className="py-3 text-muted small text-uppercase fw-bold border-0">Sabuk</th>
                                                </>
                                            )}

                                            <th className="py-3 text-muted small text-uppercase fw-bold border-0 text-center">Status</th>
                                            <th className="py-3 pe-4 text-muted small text-uppercase fw-bold border-0 text-end">Aksi</th>
                                        </tr>
                                    </thead>

                                    <tbody className="border-top-0">
                                        {athletes.map((item) => (
                                            <tr key={item.uuid} className="hover-up-row">
                                                <td className="ps-4 py-3 border-bottom-0">
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="position-relative" style={{ width: 45, height: 45 }}>
                                                            <AvatarWithFallback item={item} baseUrl={BASE_URL} />
                                                        </div>

                                                        <div>
                                                            <h6 className="mb-0 fw-bold text-dark text-uppercase">{item.name}</h6>
                                                            <small className="text-muted d-flex align-items-center gap-1 mt-1">
                                                                {item.gender === 'Lelaki' || item.gender === 'L'
                                                                    ? <FaMars className="text-primary" />
                                                                    : <FaVenus className="text-danger" />
                                                                }
                                                                {getGenderLabel(item.gender)}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td className="border-bottom-0">
                                                    <span className="fw-medium text-dark text-uppercase">{item.team ? item.team.name : "-"}</span>
                                                </td>

                                                {activeTab.id === 'kyorugi_prestasi' && (
                                                    <>
                                                        <td className="border-bottom-0 fw-bold">{item.division}</td>
                                                        <td className="border-bottom-0 text-muted">
                                                            {item.weight_class || '-'}
                                                            {filterAlone && (
                                                                <span className="badge bg-danger bg-opacity-10 text-danger border border-danger ms-2" style={{ fontSize: '0.65rem' }}>Tanpa Lawan</span>
                                                            )}
                                                        </td>
                                                    </>
                                                )}

                                                {activeTab.id === 'kyorugi_festival' && (
                                                    <>
                                                        <td className="border-bottom-0 fw-bold">{item.birth_year ? currentYear - item.birth_year : '-'} Thn</td>
                                                        <td className="border-bottom-0 text-muted">{item.actual_weight || item.declared_weight || '-'}</td>
                                                        <td className="border-bottom-0 text-muted">{item.height || '-'}</td>
                                                        <td className="border-bottom-0">
                                                            <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-3 py-2">
                                                                {item.belt || '-'}
                                                            </span>
                                                        </td>
                                                    </>
                                                )}

                                                <td className="text-center border-bottom-0">
                                                    <span className={`badge rounded-pill px-3 py-2 shadow-sm ${item.weigh_in_status === 'Pass' ? 'bg-success bg-opacity-25 text-success border border-success border-opacity-50' : item.weigh_in_status === 'Pending' ? 'bg-warning bg-opacity-25 text-warning border border-warning border-opacity-50' : 'bg-secondary bg-opacity-25 text-secondary border border-secondary border-opacity-50'}`}>
                                                        {item.weigh_in_status || 'Registered'}
                                                    </span>
                                                </td>

                                                <td className="pe-4 text-end border-bottom-0">
                                                    <div className="d-flex justify-content-end gap-2">
                                                        <button onClick={() => navigate(`/admin/atlet/edit/${item.uuid}`)} className="btn btn-sm btn-light text-primary border rounded-circle p-2 shadow-sm hover-scale" title="Edit">
                                                            <FaEdit />
                                                        </button>
                                                        <button className="btn btn-sm btn-light text-danger border rounded-circle p-2 shadow-sm hover-scale" title="Hapus" onClick={() => setDeleteModal({ show: true, uuid: item.uuid })}>
                                                            <FaTrash />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div className="card-footer bg-white p-4 border-top d-flex justify-content-between align-items-center">
                        <small className="text-muted fw-bold">Halaman {page} dari {totalPages || 1}</small>
                        <nav>
                            <ul className="pagination pagination-sm mb-0 gap-1 shadow-sm rounded">
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link border-0 text-dark fw-bold" onClick={handlePrevPage}>Prev</button>
                                </li>
                                <li className="page-item active">
                                    <button className="page-link border-0 bg-primary fw-bold px-3">{page}</button>
                                </li>
                                <li className={`page-item ${page >= totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                                    <button className="page-link border-0 text-dark fw-bold" onClick={handleNextPage}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            {importModal && createPortal(
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 1050, backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(3px)' }}>
                    <div className="card border-0 shadow-lg rounded-4 p-0 overflow-hidden" style={{ width: '90%', maxWidth: '560px', animation: 'popIn 0.3s ease-out' }}>
                        <div className="card-header bg-white p-4 border-bottom d-flex justify-content-between align-items-center">
                            <h5 className="fw-bold m-0 text-dark d-flex align-items-center gap-2">
                                <FaUpload className="text-primary" /> Import Atlet Kyorugi
                            </h5>
                            <button onClick={() => setImportModal(false)} className="btn btn-sm btn-light rounded-circle hover-scale text-danger">
                                <FaTimes />
                            </button>
                        </div>

                        <form onSubmit={submitImport}>
                            <div className="card-body p-4">
                                <div className="alert alert-info border-0 bg-info bg-opacity-10 small mb-4 rounded-3 d-flex gap-2">
                                    <FaExclamationTriangle className="mt-1 flex-shrink-0" />
                                    <div>
                                        <strong>Format Kolom CSV / Excel:</strong><br />
                                        <b>Kyorugi Prestasi:</b> <i>Tim, Nama, Gender(L/P), Umur, Tinggi, Berat, Kelas</i><br />
                                        <b>Kyorugi Festival:</b> <i>Tim, Nama, Gender(L/P), Umur, Tinggi, Berat, Sabuk</i><br />
                                        <span className="text-danger fw-bold">Catatan:</span> Kyorugi Festival hanya menerima sabuk Putih sampai Hijau Strip.
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold small text-muted">1. Tipe Pertandingan</label>
                                    <div className="d-flex gap-3">
                                        <label className={`btn w-50 d-flex justify-content-center align-items-center fw-bold transition-all ${importData.athlete_type === 'Prestasi' ? 'btn-primary text-white shadow-sm border-primary' : 'btn-outline-primary bg-light text-muted border-0'}`}>
                                            <input
                                                type="radio"
                                                name="athlete_type"
                                                className="d-none"
                                                value="Prestasi"
                                                checked={importData.athlete_type === 'Prestasi'}
                                                onChange={(e) => setImportData({ ...importData, athlete_type: e.target.value })}
                                            />
                                            Prestasi
                                        </label>

                                        <label className={`btn w-50 d-flex justify-content-center align-items-center fw-bold transition-all ${importData.athlete_type === 'Festival' ? 'btn-danger text-white shadow-sm border-danger' : 'btn-outline-danger bg-light text-muted border-0'}`}>
                                            <input
                                                type="radio"
                                                name="athlete_type"
                                                className="d-none"
                                                value="Festival"
                                                checked={importData.athlete_type === 'Festival'}
                                                onChange={(e) => setImportData({ ...importData, athlete_type: e.target.value })}
                                            />
                                            Festival
                                        </label>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold small text-muted">2. Upload File Excel/CSV</label>
                                    <input
                                        type="file"
                                        className="form-control bg-light"
                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        required
                                        onChange={(e) => setImportData({ ...importData, file: e.target.files[0] })}
                                    />
                                </div>
                            </div>

                            <div className="card-footer bg-light p-3 text-end border-top-0 d-flex gap-2 justify-content-end">
                                <button type="button" className="btn btn-light fw-bold px-4 hover-scale border" onClick={() => setImportModal(false)}>Batal</button>
                                <button type="submit" className="btn btn-primary fw-bold shadow-sm d-flex align-items-center gap-2 px-4 hover-scale" disabled={isImporting}>
                                    {isImporting ? <><div className="spinner-border spinner-border-sm"></div> Memproses...</> : <><FaUpload /> Import</>}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>,
                document.body
            )}

            {deleteModal.show && createPortal(
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 1050, backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(3px)' }}>
                    <div className="card border-0 shadow-lg rounded-4 p-4 text-center" style={{ maxWidth: '400px', width: '90%', animation: 'popIn 0.3s ease-out' }}>
                        <div className="mb-3">
                            <div className="bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex p-3">
                                <FaExclamationTriangle size={40} />
                            </div>
                        </div>
                        <h5 className="fw-bold text-dark">Hapus Data Atlet?</h5>
                        <p className="text-muted small mb-4">Tindakan ini bersifat permanen. Segala riwayat tanding dan medali atlet ini juga akan ikut terhapus. Lanjutkan?</p>
                        <div className="d-flex justify-content-center gap-2">
                            <button className="btn btn-light fw-bold rounded-pill px-4 hover-scale" onClick={() => setDeleteModal({ show: false, uuid: null })}>Batal</button>
                            <button className="btn btn-danger fw-bold rounded-pill px-4 shadow-sm hover-scale" onClick={executeDelete}>Ya, Hapus Permanen</button>
                        </div>
                    </div>
                </div>,
                document.body
            )}

            <style>{`
                .animate-fade-in { animation: fadeIn 0.4s ease-out forwards; }
                .hover-scale { transition: transform 0.2s; }
                .hover-scale:hover { transform: scale(1.02); } 
                .hover-up-row { transition: background-color 0.2s; }
                .hover-up-row:hover { background-color: #f8f9fa !important; }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes popIn { 
                    0% { transform: scale(0.9); opacity: 0; } 
                    100% { transform: scale(1); opacity: 1; } 
                }
            `}</style>
        </>
    );
};

export default AdminAthleteKyorugi;